import { SelectHelper } from '../modules/select-helper.js';

/**
 * 通知設定ページ用のスクリプト
 */
var mail_setting_treemultiselect = null;

if (is_route('mail_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        mail_setting_event_set();
        mail_setting_setting_event_set();
        mail_setting_dangerous_driving_event_set()
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.mail_setting_event_set = function() {

    /*---- ページタブ切り替え時 ----*/

    // タブ切り替え時
    $(document).on('click', '[data-page-type]', function() {
        $('#search-form-type').val($(this).data('page-type'));
        $('#search-form-type').trigger('change');
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id']);
    });

    // 詳細画面モーダルの送信ボタン押下時（個別通知）
    $(document).on('click', '#mail_setting_individual_send_btn', function () {
        const action = $(this).data('action');
        const data = {'id': $(this).data('id'), 'send_type':$(this).data('send_type'), 'is_available': $(this).data('is_available')};
        _ajax.post(action, data, function (results) {
            toastr.success(results.messages);
            load_contents(function() {
                $('[data-detail-modal=mail_setting-individual_detail-modal][data-id=' + results.setting.id + ']').trigger('click');
            });
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
            load_contents();
        });
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        const clickedElement = $(this);
        _modal.create(this, 'setting-modal', ['id', 'type'], false, function() {
            mail_setting_treemultiselect = initialize_treemultiselect();
            // 個別通知設定の場合
            if (clickedElement.data('setting-modal') == '#mail_setting-individual_setting-modal') {
                mail_setting_control_inputs_by_send_type();
                mail_setting_control_send_btn();
            }
        });
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            // ALC通知
            $('[data-detail-modal=mail_setting-detail-modal][data-id=' + results.mail_setting.id + ']').trigger('click');
            // 個別通知
            $('[data-detail-modal=mail_setting-individual_detail-modal][data-id=' + results.mail_setting.id + ']').trigger('click');

            // 危険運転イベント通知
            if (results.data?.id) {
                $('[data-detail-modal=modal-view][data-id=' + results.data.id + ']').trigger('click');
            }
        }, function() {
            mail_setting_set_steper_error();
        });
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#mail_setting-all-delete', function () {
        $(".mail_setting-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.mail_setting-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#mail_setting-all-delete, .mail_setting-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#mail_setting-multi-delete-button').prop('disabled', ($('.mail_setting-delete:checked').length == 0));
    });

    /*---- 除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.mail_setting-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#mail_setting-detail-modal');
        });
    });

}
/**
 * 設定モーダル表示時のイベント設定
 * @uses ダッシュボードからモーダル表示する際にも呼び出される
 */
window.mail_setting_setting_event_set = function() {

    /*---- ALC通知用 ----*/

    // 送信イベント変更時
    $(document).on('change', '#mail_setting-setting-modal-send_events', function () {
        let value = $(this).val();
        if(value == 1){
            $('.setting-part').each(function() {
                $(this).removeClass('display-none');
            });
        }else{
            $('.setting-part').each(function() {
                $(this).addClass('display-none');
            });
            $('.setting-'+value).removeClass('display-none');
        }
    });

    /*---- 個別通知用 ----*/

    // 送信タイミング変更時
    $(document).on('change', '#mail_setting-individual_setting-modal-send_type', function () {
        mail_setting_control_inputs_by_send_type();
        mail_setting_control_send_btn();
    });

    // 有効無効変更時
    $(document).on('change', '[name="is_available"]', function () {
        mail_setting_control_send_btn();
    });

    // 送信方法変更時
    $(document).on('change', '#mail_setting-individual_setting-modal-send_method', function () {
        const typeNum = Number($(this).val());
        const sectionIds = $('select.sections-select').val();
        if (typeNum && sectionIds.length > 0) {
            const type = typeNum === 1 ? 'is_authenticated' : 'has_email';
            setTreeMultiSelect(this, 'select.users-select', {'section_ids': sectionIds, 'type': type});
        }
    });

    /*---- ALC通知と個別通知共通 ----*/

    // ステップボタンクリック時（新規登録時）
    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        const formId = '#' + $(this).closest('.modal-content').find('form').attr('id');
        const modalId = formId.replace(/-form$/, "");
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $(modalId + '-confirm_step').val($(this).data('confirm-step'));
        // 送信前にエラーをリセット
        _error.reset()
        mail_setting_set_steper_error(false);
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown, false);
            // ステップエラーを表示
            mail_setting_set_steper_error();
        });
    });

    // 営業所変更時
    $(document).on('change', 'select.sections-select', function () {
        // 危険運転通知イベント用
        if (['modal-add-form', 'modal-edit-form'].includes($(this).parents('form').attr('id'))) {
            const dangerousDrivingEventCompanyId = $('[data-mail-setting-on-company-select-change="true"]').val();
            const dangerousDrivingEventSectionIds = $(this).val();
            if (dangerousDrivingEventCompanyId && dangerousDrivingEventSectionIds.length >= 1) {
                setTreeMultiSelect(this, 'select.users-select', {
                    'company_id': dangerousDrivingEventCompanyId,
                    'section_ids': dangerousDrivingEventSectionIds,
                });
            }
            return;
        }

        let companyId = $('#mail_setting-setting-modal-company_id').val();
        let sectionIds = $(this).val();
        if ($(this).parents('form').attr('id') == 'mail_setting-individual_setting-modal-form') {
            // 個別通知用
            const typeNum = Number($('#mail_setting-individual_setting-modal-send_method').val());
            if (typeNum) {
                const type = typeNum === 1 ? 'is_authenticated' : 'has_email';
                setTreeMultiSelect(this, 'select.users-select', {'company_id': companyId, 'section_ids': sectionIds, 'type': type});
            }
        } else {
            // ALC通知用
            setTreeMultiSelect(this, 'select.users-select', {'company_id': companyId, 'section_ids': sectionIds});
        }
    });

    // セレクトの値をセットする
    function setTreeMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            _ajax.post(action, datas, function (results) {
                $(select).empty();
                mail_setting_treemultiselect[0][0].remove();
                mail_setting_treemultiselect[0][0].reload();
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id,
                        'data-section': option.section_name
                    }).text(option.text));
                })
                mail_setting_treemultiselect[0][0].reload();
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

}


/**
 * ステッパーへのエラー表示処理
 * @param {*} showError
 */
window.mail_setting_set_steper_error = function (showError = true) {
    // ALC通知用
    if ($('#mail_setting-setting-modal-form').length > 0) {
        if (showError) {
            $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
            $('#mail-part-trigger').toggleClass('error', ($('#mail-part').find('.invalid-feedback:not(.copy)').length > 0));
        } else {
            $('#base-part-trigger').removeClass('error');
            $('#mail-part-trigger').removeClass('error');
        }
    // 個別通知用
    } else if ($('#mail_setting-individual_setting-modal-form').length > 0) {
        if (showError) {
            $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
            $('#contents-part-trigger').toggleClass('error', ($('#contents-part').find('.invalid-feedback:not(.copy)').length > 0));
            $('#recipiens-part-trigger').toggleClass('error', ($('#recipiens-part').find('.invalid-feedback:not(.copy)').length > 0));
        } else {
            $('#base-part-trigger').removeClass('error');
            $('#contents-part-trigger').removeClass('error');
            $('#recipients-part-trigger').removeClass('error');
        }
    }
}

/*---- 個別通知用 ----*/

// 通知タイミングによる送信日・送信曜日・送信時間の表示／非表示制御
window.mail_setting_control_inputs_by_send_type = function() {
    const targets = $('.toggle-target-for-send-type');
    const sendType = $('#mail_setting-individual_setting-modal-send_type').val();
    if (sendType == 1 || sendType == ''){ // 即時 or 未選択
        targets.each(function() {
            $(this).addClass('d-none');
        });
    } else if (sendType == 2){ // 毎月
        targets.each(function() {
            $(this).find('[name="send_weekday"]').length > 0 ? $(this).addClass('d-none') : $(this).removeClass('d-none');
        });
    } else if (sendType == 3){ // 毎週
        targets.each(function() {
            $(this).find('[name="send_day"]').length > 0 ? $(this).addClass('d-none') : $(this).removeClass('d-none');
        });
    } else if (sendType == 4){ // 毎日
        targets.each(function() {
            $(this).find('[name="send_time"]').length > 0 ? $(this).removeClass('d-none') : $(this).addClass('d-none');
        });
    }
    targets.each(function() {
        $(this).hasClass('d-none') ? $(this).find('input, select').prop("disabled", true) : $(this).find('input, select').prop("disabled", false);
    });
}

// 設定画面の送信ボタンの表示／非表示制御
window.mail_setting_control_send_btn = function() {
    const sendType = $('#mail_setting-individual_setting-modal-send_type').val();
    const isAvailable = $('#mail_setting-individual_setting-modal-is_available_1').is(':checked');
    if (sendType == 1 && isAvailable){
        // 即時でなおかつ有効の場合のみ、送信ボタンを表示して保存ボタンを消す。
        $('[data-save-modal]').each(function() {
            $(this).hasClass('send-btn') ? $(this).removeClass('d-none') : $(this).addClass('d-none');
        })
    } else {
        $('[data-save-modal]').each(function() {
            $(this).hasClass('send-btn') ?  $(this).addClass('d-none') : $(this).removeClass('d-none');
        })
    }
}

window.mail_setting_dangerous_driving_event_set = () => {
    // ==================================================
    // [data-mail-setting-on-holding-select-change="true"] 付き要素の変更時に、
    // 選択されたグループ会社に応じて会社セレクトを更新します。
    // ==================================================
    $(document).on('change', '[data-mail-setting-on-holding-select-change="true"]', (event) => {
        const element = event.currentTarget;

        if ($(element).find('option:selected').length === 0 || $(element).find('option:selected').val() === '') {
            SelectHelper.clear(element, '[data-mail-setting-on-company-select-change="true"]');
            return;
        }

        SelectHelper.update(element, '[data-mail-setting-on-company-select-change="true"]', {
            'holding_id': $(element).val(),
        });
    });

    // ==================================================
    // [data-mail-setting-on-company-select-change="true"] 付き要素の変更時に、
    // 選択された会社に応じて営業所セレクトを更新します。
    // ==================================================
    $(document).on('change', '[data-mail-setting-on-company-select-change="true"]', (event) => {
        const element = event.currentTarget;

        if ($(element).find('option:selected').length === 0 || $(element).find('option:selected').val() === '') {
            SelectHelper.clear(element, '[data-mail-setting-on-section-select-change="true"]');
            SelectHelper.clearMulti(element, '[data-mail-setting-on-section-multi-select-change="true"]');
            return;
        }

        SelectHelper.update(element, '[data-mail-setting-on-section-select-change="true"]', {
            'holding_id': $('[data-mail-setting-on-holding-select-change="true"]').val(),
            'company_id': $(element).val(),
        });

        SelectHelper.updateMulti(element, '[data-mail-setting-on-section-multi-select-change="true"]', {
            'holding_id': $('[data-mail-setting-on-holding-select-change="true"]').val(),
            'company_id': $(element).val(),
        }, { showEmptyOption: false });
    });

    $(document).on('shown.bs.modal', '#modal-add', (event) => {
        const $modal = $(event.currentTarget);
        const $companySelects = $modal.find('select[data-mail-setting-on-company-select-change="true"]');
        const hasCompanyValue = $companySelects.toArray()
            .some(element => $(element).val());

        if (hasCompanyValue) {
            $companySelects.each((_, element) => $(element).trigger('change'));
            return;
        }

        $modal.find('select[data-mail-setting-on-holding-select-change="true"]')
            .each((_, element) => {
                if ($(element).val()) {
                    $(element).trigger('change');
                }
            });
    });
};
